var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlayContainer"},[_c('div',{ref:"pollContainer",attrs:{"id":"pollContainer"}}),_c('div',{ref:"slideContainer",style:(_vm.slideVisible ? 'dispay:flex;' : 'display:none;'),attrs:{"id":"slideContainer"}})])}
var staticRenderFns = []

export { render, staticRenderFns }